// ============================================================
// SEO LOCAL — Dataset central : villes × services
// Génère automatiquement des centaines de pages optimisées
// pour capter toutes les recherches "informatique + ville Hérault"
// ============================================================

export interface City {
  slug: string;
  name: string;
  postalCode: string;
  department: string; // "34" Hérault, "11" Aude
  population?: number;
  distance: string; // depuis Béziers
  lat: number;
  lng: number;
  description: string;
  nearbyCities: string[]; // slugs
}

export interface ServiceType {
  slug: string;          // ex: "reparation-pc"
  name: string;          // ex: "Réparation PC"
  shortName: string;     // ex: "Réparation"
  category: string;
  priceFrom: number;     // €
  priceUnit?: string;    // "€" | "€/mois"
  description: string;
  longDescription: string;
  benefits: string[];
  duration: string;      // ex: "1-2h"
  warranty: string;
  faq: { q: string; a: string }[];
  ctaPath: string;       // page interne associée
  schemaType: string;    // schema.org Service type
}

// ===== 30 VILLES Hérault + Aude (zones d'intervention) =====
export const cities: City[] = [
  { slug: "beziers", name: "Béziers", postalCode: "34500", department: "34", population: 78000, distance: "Zone principale", lat: 43.3441, lng: 3.2197,
    description: "Préfecture historique du Biterrois, Béziers est la zone d'intervention principale de SUDWEB-TECH.",
    nearbyCities: ["serignan", "vendres", "sauvian", "villeneuve-les-beziers", "boujan-sur-libron"] },
  { slug: "vendres", name: "Vendres", postalCode: "34350", department: "34", distance: "10 km", lat: 43.2731, lng: 3.2114,
    description: "Vendres et son étang, à 10 minutes de Béziers — siège de SUDWEB-TECH.",
    nearbyCities: ["lespignan", "valras-plage", "serignan", "sauvian", "beziers"] },
  { slug: "serignan", name: "Sérignan", postalCode: "34410", department: "34", distance: "8 km", lat: 43.2789, lng: 3.2839,
    description: "Sérignan, station balnéaire et résidentielle à 8 km de Béziers.",
    nearbyCities: ["valras-plage", "vendres", "sauvian", "villeneuve-les-beziers", "portiragnes"] },
  { slug: "valras-plage", name: "Valras-Plage", postalCode: "34350", department: "34", distance: "15 km", lat: 43.2456, lng: 3.2956,
    description: "Valras-Plage, station balnéaire familiale du littoral biterrois.",
    nearbyCities: ["serignan", "vendres", "sauvian", "vias", "portiragnes"] },
  { slug: "sauvian", name: "Sauvian", postalCode: "34410", department: "34", distance: "5 km", lat: 43.2856, lng: 3.2589,
    description: "Sauvian, commune dynamique de l'agglomération biterroise.",
    nearbyCities: ["serignan", "beziers", "vendres", "villeneuve-les-beziers", "valras-plage"] },
  { slug: "villeneuve-les-beziers", name: "Villeneuve-lès-Béziers", postalCode: "34420", department: "34", distance: "6 km", lat: 43.3175, lng: 3.2939,
    description: "Villeneuve-lès-Béziers, en bord de Canal du Midi.",
    nearbyCities: ["beziers", "serignan", "sauvian", "portiragnes", "boujan-sur-libron"] },
  { slug: "boujan-sur-libron", name: "Boujan-sur-Libron", postalCode: "34760", department: "34", distance: "7 km", lat: 43.3672, lng: 3.2531,
    description: "Boujan-sur-Libron, commune résidentielle au nord de Béziers.",
    nearbyCities: ["beziers", "lignan-sur-orb", "bassan", "servian", "maraussan"] },
  { slug: "maraussan", name: "Maraussan", postalCode: "34370", department: "34", distance: "8 km", lat: 43.3661, lng: 3.1525,
    description: "Maraussan, capitale du muscat à l'ouest de Béziers.",
    nearbyCities: ["beziers", "cazouls-les-beziers", "thezan-les-beziers", "lignan-sur-orb", "puisserguier"] },
  { slug: "cazouls-les-beziers", name: "Cazouls-lès-Béziers", postalCode: "34370", department: "34", distance: "12 km", lat: 43.3925, lng: 3.1136,
    description: "Cazouls-lès-Béziers, pôle viticole de l'arrière-pays biterrois.",
    nearbyCities: ["maraussan", "puisserguier", "creissan", "beziers", "thezan-les-beziers"] },
  { slug: "servian", name: "Servian", postalCode: "34290", department: "34", distance: "13 km", lat: 43.4017, lng: 3.3014,
    description: "Servian, sur la route de Pézenas, à 13 km de Béziers.",
    nearbyCities: ["pezenas", "beziers", "boujan-sur-libron", "valros", "tourbes"] },
  { slug: "pezenas", name: "Pézenas", postalCode: "34120", department: "34", distance: "20 km", lat: 43.4603, lng: 3.4239,
    description: "Pézenas, ville d'art et d'histoire à 20 km de Béziers.",
    nearbyCities: ["servian", "florensac", "agde", "montagnac", "caux"] },
  { slug: "agde", name: "Agde", postalCode: "34300", department: "34", distance: "25 km", lat: 43.3128, lng: 3.4742,
    description: "Agde et le Cap d'Agde, station touristique majeure de l'Hérault.",
    nearbyCities: ["vias", "marseillan", "portiragnes", "florensac", "pezenas"] },
  { slug: "vias", name: "Vias", postalCode: "34450", department: "34", distance: "20 km", lat: 43.3128, lng: 3.4178,
    description: "Vias, station balnéaire entre Agde et Béziers.",
    nearbyCities: ["agde", "portiragnes", "valras-plage", "serignan", "marseillan"] },
  { slug: "portiragnes", name: "Portiragnes", postalCode: "34420", department: "34", distance: "12 km", lat: 43.2911, lng: 3.3517,
    description: "Portiragnes-Plage, station familiale du littoral.",
    nearbyCities: ["vias", "serignan", "villeneuve-les-beziers", "valras-plage", "agde"] },
  { slug: "marseillan", name: "Marseillan", postalCode: "34340", department: "34", distance: "32 km", lat: 43.3553, lng: 3.5375,
    description: "Marseillan et Marseillan-Plage, sur l'étang de Thau.",
    nearbyCities: ["agde", "meze", "florensac", "pezenas", "sete"] },
  { slug: "florensac", name: "Florensac", postalCode: "34510", department: "34", distance: "22 km", lat: 43.3781, lng: 3.4639,
    description: "Florensac, capitale du Picpoul, entre Pézenas et Agde.",
    nearbyCities: ["pezenas", "agde", "marseillan", "meze", "servian"] },
  { slug: "meze", name: "Mèze", postalCode: "34140", department: "34", distance: "40 km", lat: 43.4253, lng: 3.6044,
    description: "Mèze, port ostréicole de l'étang de Thau.",
    nearbyCities: ["marseillan", "loupian", "bouzigues", "sete", "florensac"] },
  { slug: "sete", name: "Sète", postalCode: "34200", department: "34", population: 44000, distance: "45 km", lat: 43.4047, lng: 3.6936,
    description: "Sète, île singulière entre mer et étang.",
    nearbyCities: ["frontignan", "balaruc-les-bains", "meze", "marseillan", "loupian"] },
  { slug: "frontignan", name: "Frontignan", postalCode: "34110", department: "34", distance: "50 km", lat: 43.4467, lng: 3.7556,
    description: "Frontignan, capitale du muscat et porte de Sète.",
    nearbyCities: ["sete", "balaruc-les-bains", "vic-la-gardiole", "mireval", "gigean"] },
  { slug: "balaruc-les-bains", name: "Balaruc-les-Bains", postalCode: "34540", department: "34", distance: "45 km", lat: 43.4408, lng: 3.6789,
    description: "Balaruc-les-Bains, première station thermale de France.",
    nearbyCities: ["sete", "frontignan", "loupian", "bouzigues", "gigean"] },
  { slug: "lunel", name: "Lunel", postalCode: "34400", department: "34", distance: "85 km", lat: 43.6772, lng: 4.1394,
    description: "Lunel, entre Montpellier et Nîmes.",
    nearbyCities: ["montpellier", "lunel-viel", "marsillargues", "saint-just", "lansargues"] },
  { slug: "montpellier", name: "Montpellier", postalCode: "34000", department: "34", population: 295000, distance: "70 km", lat: 43.6108, lng: 3.8767,
    description: "Montpellier, métropole de l'Hérault, 8e ville de France.",
    nearbyCities: ["castelnau-le-lez", "lattes", "perols", "saint-jean-de-vedas", "juvignac"] },
  { slug: "castelnau-le-lez", name: "Castelnau-le-Lez", postalCode: "34170", department: "34", distance: "70 km", lat: 43.6336, lng: 3.9028,
    description: "Castelnau-le-Lez, banlieue est de Montpellier.",
    nearbyCities: ["montpellier", "le-cres", "clapiers", "jacou", "vendargues"] },
  { slug: "lattes", name: "Lattes", postalCode: "34970", department: "34", distance: "72 km", lat: 43.5681, lng: 3.9072,
    description: "Lattes, sud de Montpellier, zone Odysseum/Pérols.",
    nearbyCities: ["montpellier", "perols", "palavas-les-flots", "saint-jean-de-vedas", "villeneuve-les-maguelone"] },
  { slug: "clermont-l-herault", name: "Clermont-l'Hérault", postalCode: "34800", department: "34", distance: "55 km", lat: 43.6275, lng: 3.4253,
    description: "Clermont-l'Hérault, lac du Salagou et arrière-pays.",
    nearbyCities: ["pezenas", "lodeve", "gignac", "paulhan", "canet"] },
  { slug: "lodeve", name: "Lodève", postalCode: "34700", department: "34", distance: "70 km", lat: 43.7311, lng: 3.3164,
    description: "Lodève, porte des Hauts Cantons de l'Hérault.",
    nearbyCities: ["clermont-l-herault", "le-bousquet-d-orb", "lunas", "soubes", "saint-jean-de-la-blaquiere"] },
  { slug: "narbonne", name: "Narbonne", postalCode: "11100", department: "11", population: 56000, distance: "30 km", lat: 43.1842, lng: 3.0033,
    description: "Narbonne, première colonie romaine de Gaule, à 30 km de Béziers.",
    nearbyCities: ["coursan", "cuxac-d-aude", "lezignan-corbieres", "capestang", "nissan-lez-enserune"] },
  { slug: "lezignan-corbieres", name: "Lézignan-Corbières", postalCode: "11200", department: "11", distance: "50 km", lat: 43.2008, lng: 2.7572,
    description: "Lézignan-Corbières, capitale viticole du Minervois.",
    nearbyCities: ["narbonne", "carcassonne", "olonzac", "homps", "capestang"] },
  { slug: "capestang", name: "Capestang", postalCode: "34310", department: "34", distance: "18 km", lat: 43.3306, lng: 3.0444,
    description: "Capestang, sur le Canal du Midi, entre Béziers et Narbonne.",
    nearbyCities: ["beziers", "nissan-lez-enserune", "puisserguier", "narbonne", "creissan"] },
  { slug: "nissan-lez-enserune", name: "Nissan-lez-Enserune", postalCode: "34440", department: "34", distance: "13 km", lat: 43.2811, lng: 3.1167,
    description: "Nissan-lez-Enserune, oppidum antique près de Béziers.",
    nearbyCities: ["beziers", "capestang", "lespignan", "vendres", "poilhes"] },
  { slug: "lespignan", name: "Lespignan", postalCode: "34710", department: "34", distance: "11 km", lat: 43.2497, lng: 3.1789,
    description: "Lespignan, commune au sud-ouest de Béziers.",
    nearbyCities: ["vendres", "nissan-lez-enserune", "fleury-d-aude", "vinassan", "beziers"] },
  { slug: "lignan-sur-orb", name: "Lignan-sur-Orb", postalCode: "34490", department: "34", distance: "9 km", lat: 43.3678, lng: 3.1817,
    description: "Lignan-sur-Orb, au nord-ouest de Béziers sur les rives de l'Orb.",
    nearbyCities: ["beziers", "maraussan", "boujan-sur-libron", "corneilhan", "puimisson"] },
  { slug: "puisserguier", name: "Puisserguier", postalCode: "34620", department: "34", distance: "16 km", lat: 43.3622, lng: 3.0367,
    description: "Puisserguier, à l'ouest de Béziers, terre viticole.",
    nearbyCities: ["maraussan", "cazouls-les-beziers", "creissan", "capestang", "saint-chinian"] },
  { slug: "thezan-les-beziers", name: "Thézan-lès-Béziers", postalCode: "34490", department: "34", distance: "14 km", lat: 43.4061, lng: 3.0858,
    description: "Thézan-lès-Béziers, capitale viticole du Languedoc.",
    nearbyCities: ["maraussan", "cazouls-les-beziers", "murviel-les-beziers", "causses-et-veyran", "lignan-sur-orb"] },
  { slug: "saint-chinian", name: "Saint-Chinian", postalCode: "34360", department: "34", distance: "25 km", lat: 43.4197, lng: 2.9486,
    description: "Saint-Chinian, AOC viticole, dans le Haut-Languedoc.",
    nearbyCities: ["puisserguier", "cessenon-sur-orb", "pierrerue", "creissan", "babeau-bouldoux"] },
  { slug: "cessenon-sur-orb", name: "Cessenon-sur-Orb", postalCode: "34460", department: "34", distance: "30 km", lat: 43.4536, lng: 3.0467,
    description: "Cessenon-sur-Orb, dans la vallée de l'Orb.",
    nearbyCities: ["saint-chinian", "cazouls-les-beziers", "roquebrun", "berlou", "vieussan"] },
  { slug: "murviel-les-beziers", name: "Murviel-lès-Béziers", postalCode: "34490", department: "34", distance: "16 km", lat: 43.4467, lng: 3.1042,
    description: "Murviel-lès-Béziers, au cœur du vignoble.",
    nearbyCities: ["thezan-les-beziers", "causses-et-veyran", "autignac", "magalas", "laurens"] },
  { slug: "magalas", name: "Magalas", postalCode: "34480", department: "34", distance: "20 km", lat: 43.4519, lng: 3.2253,
    description: "Magalas, sur la route entre Béziers et Saint-Chinian.",
    nearbyCities: ["murviel-les-beziers", "puimisson", "laurens", "espondeilhan", "pouzolles"] },
  { slug: "bessan", name: "Bessan", postalCode: "34550", department: "34", distance: "18 km", lat: 43.3592, lng: 3.4197,
    description: "Bessan, entre Pézenas et Agde.",
    nearbyCities: ["agde", "pezenas", "florensac", "saint-thibery", "marseillan"] },
  { slug: "saint-thibery", name: "Saint-Thibéry", postalCode: "34630", department: "34", distance: "15 km", lat: 43.3833, lng: 3.4192,
    description: "Saint-Thibéry, vestiges romains entre Béziers et Pézenas.",
    nearbyCities: ["bessan", "pezenas", "florensac", "tourbes", "agde"] },
  { slug: "tourbes", name: "Tourbes", postalCode: "34120", department: "34", distance: "18 km", lat: 43.4239, lng: 3.3878,
    description: "Tourbes, près de Pézenas.",
    nearbyCities: ["pezenas", "servian", "valros", "saint-thibery", "montblanc"] },
  { slug: "montblanc", name: "Montblanc", postalCode: "34290", department: "34", distance: "12 km", lat: 43.3603, lng: 3.3631,
    description: "Montblanc, entre Béziers et Pézenas.",
    nearbyCities: ["servian", "tourbes", "valros", "saint-thibery", "beziers"] },
  { slug: "loupian", name: "Loupian", postalCode: "34140", department: "34", distance: "42 km", lat: 43.4419, lng: 3.6094,
    description: "Loupian, bord d'étang de Thau, vestiges romains.",
    nearbyCities: ["meze", "bouzigues", "balaruc-les-bains", "poussan", "marseillan"] },
  { slug: "bouzigues", name: "Bouzigues", postalCode: "34140", department: "34", distance: "44 km", lat: 43.4500, lng: 3.6586,
    description: "Bouzigues, capitale de l'huître de Thau.",
    nearbyCities: ["loupian", "meze", "balaruc-les-bains", "poussan", "sete"] },
  { slug: "poussan", name: "Poussan", postalCode: "34560", department: "34", distance: "48 km", lat: 43.4778, lng: 3.6711,
    description: "Poussan, près de l'étang de Thau.",
    nearbyCities: ["loupian", "bouzigues", "gigean", "balaruc-les-bains", "mireval"] },
  { slug: "gigean", name: "Gigean", postalCode: "34770", department: "34", distance: "50 km", lat: 43.5008, lng: 3.7194,
    description: "Gigean, au pied de la Gardiole.",
    nearbyCities: ["poussan", "frontignan", "mireval", "vic-la-gardiole", "balaruc-les-bains"] },
  { slug: "mireval", name: "Mireval", postalCode: "34110", department: "34", distance: "55 km", lat: 43.5028, lng: 3.7853,
    description: "Mireval, capitale du muscat de Mireval.",
    nearbyCities: ["frontignan", "vic-la-gardiole", "gigean", "fabregues", "villeneuve-les-maguelone"] },
  { slug: "vic-la-gardiole", name: "Vic-la-Gardiole", postalCode: "34110", department: "34", distance: "55 km", lat: 43.4836, lng: 3.7975,
    description: "Vic-la-Gardiole, étangs et garrigues.",
    nearbyCities: ["mireval", "frontignan", "gigean", "villeneuve-les-maguelone", "palavas-les-flots"] },
  { slug: "palavas-les-flots", name: "Palavas-les-Flots", postalCode: "34250", department: "34", distance: "75 km", lat: 43.5283, lng: 3.9303,
    description: "Palavas-les-Flots, station balnéaire de Montpellier.",
    nearbyCities: ["montpellier", "lattes", "perols", "villeneuve-les-maguelone", "carnon"] },
  { slug: "perols", name: "Pérols", postalCode: "34470", department: "34", distance: "73 km", lat: 43.5550, lng: 3.9450,
    description: "Pérols, entre Montpellier et la mer.",
    nearbyCities: ["lattes", "montpellier", "palavas-les-flots", "mauguio", "carnon"] },
  { slug: "mauguio", name: "Mauguio", postalCode: "34130", department: "34", distance: "75 km", lat: 43.6172, lng: 4.0078,
    description: "Mauguio, capitale du Pays de l'Or.",
    nearbyCities: ["perols", "lunel", "montpellier", "candillargues", "marsillargues"] },
  { slug: "saint-jean-de-vedas", name: "Saint-Jean-de-Védas", postalCode: "34430", department: "34", distance: "70 km", lat: 43.5803, lng: 3.8264,
    description: "Saint-Jean-de-Védas, sud-ouest de Montpellier.",
    nearbyCities: ["montpellier", "lattes", "villeneuve-les-maguelone", "fabregues", "cournonterral"] },
  { slug: "gignac", name: "Gignac", postalCode: "34150", department: "34", distance: "55 km", lat: 43.6492, lng: 3.5503,
    description: "Gignac, vallée de l'Hérault.",
    nearbyCities: ["clermont-l-herault", "aniane", "saint-andre-de-sangonis", "pouzols", "tressan"] },
  { slug: "carcassonne", name: "Carcassonne", postalCode: "11000", department: "11", population: 47000, distance: "85 km", lat: 43.2130, lng: 2.3491,
    description: "Carcassonne, cité médiévale classée UNESCO.",
    nearbyCities: ["lezignan-corbieres", "narbonne", "trebes", "limoux", "bram"] },
  { slug: "gruissan", name: "Gruissan", postalCode: "11430", department: "11", distance: "40 km", lat: 43.1083, lng: 3.0858,
    description: "Gruissan, station balnéaire et village circulaire.",
    nearbyCities: ["narbonne", "port-la-nouvelle", "sigean", "bages", "peyriac-de-mer"] },
  { slug: "sigean", name: "Sigean", postalCode: "11130", department: "11", distance: "55 km", lat: 43.0303, lng: 2.9692,
    description: "Sigean, réserve africaine et étangs.",
    nearbyCities: ["port-la-nouvelle", "gruissan", "narbonne", "peyriac-de-mer", "portel-des-corbieres"] },
  { slug: "montady", name: "Montady", postalCode: "34310", department: "34", distance: "12 km", lat: 43.3439, lng: 3.1119,
    description: "Montady, célèbre pour son étang asséché en étoile, à 12 km de Béziers.",
    nearbyCities: ["capestang", "nissan-lez-enserune", "maureilhan", "colombiers", "beziers"] },
  { slug: "colombiers", name: "Colombiers", postalCode: "34440", department: "34", distance: "8 km", lat: 43.3022, lng: 3.1469,
    description: "Colombiers, port sur le Canal du Midi, à 8 km de Béziers.",
    nearbyCities: ["beziers", "nissan-lez-enserune", "montady", "lespignan", "vendres"] },
  { slug: "cers", name: "Cers", postalCode: "34420", department: "34", distance: "6 km", lat: 43.3217, lng: 3.2606,
    description: "Cers, commune résidentielle à l'est de Béziers.",
    nearbyCities: ["villeneuve-les-beziers", "portiragnes", "beziers", "boujan-sur-libron", "sauvian"] },
  { slug: "lieuran-les-beziers", name: "Lieuran-lès-Béziers", postalCode: "34290", department: "34", distance: "10 km", lat: 43.3825, lng: 3.2811,
    description: "Lieuran-lès-Béziers, au nord-est de Béziers.",
    nearbyCities: ["servian", "boujan-sur-libron", "espondeilhan", "bassan", "beziers"] },
];

// ===== 12 SERVICES — chacun croisé avec 30 villes =====
export const services: ServiceType[] = [
  {
    slug: "depannage-informatique",
    name: "Dépannage Informatique",
    shortName: "Dépannage",
    category: "Maintenance",
    priceFrom: 49,
    priceUnit: "€",
    description: "Diagnostic complet, nettoyage, dépannage à domicile ou en atelier sous 24h.",
    longDescription: "SUDWEB-TECH intervient pour tout type de panne : ordinateur qui rame, écran bleu, démarrage impossible, virus, lenteurs Windows, Wi-Fi instable. Diagnostic complet en 30 minutes, devis gratuit, intervention à domicile ou prise en charge en atelier.",
    benefits: ["Diagnostic gratuit sur place", "Intervention sous 24h ouvrées", "Devis transparent sans surprise", "Garantie 3 mois sur la réparation", "Particuliers & professionnels"],
    duration: "1 à 3 heures",
    warranty: "3 mois pièces et main d'œuvre",
    faq: [
      { q: "Combien coûte un dépannage informatique ?", a: "Le diagnostic complet est à 75€ TTC. Le tarif final dépend de la panne. Devis transparent fourni avant toute intervention." },
      { q: "Intervenez-vous à domicile ?", a: "Oui, intervention à domicile dans tout le secteur. Possibilité aussi de déposer le matériel en atelier." },
      { q: "Quel est le délai d'intervention ?", a: "En moyenne sous 24h ouvrées. Service express possible le jour même selon disponibilités." },
    ],
    ctaPath: "/contact",
    schemaType: "ComputerRepairService",
  },
  {
    slug: "reparation-pc",
    name: "Réparation PC",
    shortName: "Réparation PC",
    category: "Maintenance",
    priceFrom: 69,
    priceUnit: "€",
    description: "Réparation matérielle PC fixe et portable : alimentation, écran, clavier, ventilation.",
    longDescription: "Spécialiste de la réparation PC fixe et portable. Remplacement de composants défectueux : alimentation, carte mère, écran de portable, clavier, ventilation, disque dur, SSD. Pièces d'origine, garantie 6 mois.",
    benefits: ["Pièces d'origine constructeur", "Diagnostic offert", "Devis avant intervention", "Garantie 6 mois", "Toutes marques : HP, Dell, Asus, Lenovo, Acer, MSI"],
    duration: "1 à 5 jours selon pièces",
    warranty: "6 mois sur pièces remplacées",
    faq: [
      { q: "Réparez-vous toutes les marques ?", a: "Oui : HP, Dell, Asus, Lenovo, Acer, MSI, Apple, Samsung et toutes les marques OEM." },
      { q: "Combien de temps pour une réparation ?", a: "Entre 24h et 5 jours selon la disponibilité des pièces." },
      { q: "Que faire si le PC ne s'allume plus ?", a: "Apportez-le ou laissez-nous venir : diagnostic gratuit pour identifier l'origine (alim, carte mère, RAM)." },
    ],
    ctaPath: "/contact",
    schemaType: "ComputerRepairService",
  },
  {
    slug: "assemblage-pc-sur-mesure",
    name: "Assemblage PC Sur Mesure",
    shortName: "PC Sur Mesure",
    category: "Hardware",
    priceFrom: 890,
    priceUnit: "€",
    description: "PC gaming, station pro ou bureautique assemblé selon vos besoins, garantie 2 ans.",
    longDescription: "Configuration personnalisée 100% sur mesure : composants premium sourcés (Asus, MSI, Corsair, Samsung, NVIDIA, AMD), montage soigné en atelier, tests de stabilité 48h, installation Windows 11 + drivers, garantie 2 ans pièces et main d'œuvre.",
    benefits: ["Configuration 100% personnalisée", "Composants premium sourcés", "Tests stress 48h", "Installation Windows 11 + drivers", "Garantie 2 ans pièces et MO"],
    duration: "5 à 10 jours ouvrés",
    warranty: "2 ans pièces et main d'œuvre",
    faq: [
      { q: "Quel budget pour un PC gaming ?", a: "Configurations gaming dès 890€. Pour du 1440p haut de gamme, comptez 1500-2500€." },
      { q: "Livrez-vous le PC monté ?", a: "Oui, livraison montée et testée dans tout l'Hérault. Installation à domicile possible." },
      { q: "Puis-je upgrader plus tard ?", a: "Oui, on conçoit toutes nos configs en pensant à l'évolutivité (alim surdimensionnée, slots libres)." },
    ],
    ctaPath: "/pc-sur-mesure",
    schemaType: "Service",
  },
  {
    slug: "creation-site-web",
    name: "Création de Site Web",
    shortName: "Site Web",
    category: "Web",
    priceFrom: 590,
    priceUnit: "€",
    description: "Sites vitrines premium, e-commerce performants, SEO inclus, propriété complète du code.",
    longDescription: "Sites web modernes haute performance : vitrine, e-commerce, application web. Design sur mesure, optimisation SEO complète, hébergement géré, propriété intégrale du code source.",
    benefits: ["Design sur mesure 100% unique", "SEO local & technique inclus", "Score PageSpeed 95+/100", "Hébergement & maintenance", "Code source vous appartient"],
    duration: "2 à 6 semaines",
    warranty: "1 an de garantie technique",
    faq: [
      { q: "Combien coûte un site vitrine ?", a: "Vitrine premium dès 590€. E-commerce dès 1490€. Devis personnalisé en 24h." },
      { q: "Le SEO est-il inclus ?", a: "Oui : SEO technique, on-page, schema.org, sitemap, optimisation locale Google." },
      { q: "Suis-je propriétaire du site ?", a: "Oui, 100%. Code source remis, accès complet, aucune dépendance." },
    ],
    ctaPath: "/creation-web",
    schemaType: "Service",
  },
  {
    slug: "recuperation-donnees",
    name: "Récupération de Données",
    shortName: "Récup. Données",
    category: "Data",
    priceFrom: 89,
    priceUnit: "€",
    description: "Récupération de fichiers sur disque dur, SSD, clé USB, carte SD, même endommagés.",
    longDescription: "Service de récupération de données depuis disques durs, SSD, clés USB, cartes SD endommagés ou formatés. Diagnostic gratuit, taux de réussite supérieur à 90% sur pannes logiques.",
    benefits: ["Diagnostic gratuit & devis", "Taux de réussite > 90%", "Confidentialité absolue (NDA)", "Restitution sur support neuf", "Pannes logiques & physiques"],
    duration: "2 à 7 jours",
    warranty: "Pas de récupération = pas de facture",
    faq: [
      { q: "Combien coûte une récupération de données ?", a: "À partir de 89€ pour pannes logiques. Pannes physiques : devis selon gravité." },
      { q: "Si vous ne récupérez rien, je paie ?", a: "Non. Pas de récupération = pas de facture. Engagement contractuel." },
      { q: "Mes données restent confidentielles ?", a: "Oui, NDA systématique, données effacées après restitution." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "installation-camera-surveillance",
    name: "Installation Caméra de Surveillance",
    shortName: "Vidéosurveillance",
    category: "Sécurité",
    priceFrom: 229,
    priceUnit: "€",
    description: "Installation caméras IP intérieures et extérieures, NVR, accès distant sécurisé.",
    longDescription: "Installation complète de systèmes de vidéosurveillance : caméras IP HD/4K intérieures et extérieures, enregistreur NVR, configuration accès distant smartphone, conformité RGPD.",
    benefits: ["Caméras IP HD ou 4K", "Vision nocturne & extérieure IP67", "Accès smartphone sécurisé", "Stockage local NVR", "Conformité RGPD"],
    duration: "1 journée pour pack 4 caméras",
    warranty: "2 ans matériel, 1 an installation",
    faq: [
      { q: "Combien coûte une caméra installée ?", a: "1 caméra IP + pose dès 229€. Pack 4 caméras + NVR : 749€." },
      { q: "Puis-je voir les caméras à distance ?", a: "Oui, accès smartphone sécurisé inclus dans toutes nos installations." },
      { q: "Est-ce conforme RGPD ?", a: "Oui : déclaration, signalétique, durée de conservation conformes." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "installation-wifi-reseau",
    name: "Installation Wifi et Réseau",
    shortName: "Wifi & Réseau",
    category: "Réseau",
    priceFrom: 119,
    priceUnit: "€",
    description: "Audit Wifi, point d'accès, câblage Ethernet, configuration NAS et serveurs.",
    longDescription: "Audit Wifi complet, installation de points d'accès Ubiquiti/TP-Link, câblage Ethernet structuré CAT6, configuration NAS Synology/QNAP, serveurs pro.",
    benefits: ["Audit Wifi cartographié", "Matériel pro (Ubiquiti, TP-Link)", "Câblage CAT6 structuré", "Configuration NAS sécurisée", "Maintenance possible"],
    duration: "Selon ampleur (½ à 3 jours)",
    warranty: "1 an installation",
    faq: [
      { q: "Combien coûte un audit Wifi ?", a: "Audit Wifi complet + plan d'optimisation : 119€." },
      { q: "Faut-il refaire le câblage ?", a: "Pas toujours. L'audit détermine si du Wifi mesh suffit ou si du câblage est nécessaire." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "installation-domotique",
    name: "Installation Domotique",
    shortName: "Domotique",
    category: "Maison connectée",
    priceFrom: 349,
    priceUnit: "€",
    description: "Maison intelligente clé en main : éclairage, volets, chauffage, scénarios automatisés.",
    longDescription: "Installation domotique complète : éclairage connecté Philips Hue, volets Somfy, thermostats Netatmo, scénarios automatisés, intégration Google Assistant / Alexa / Apple HomeKit.",
    benefits: ["Audit personnalisé gratuit", "Solutions sans fil ou filaire", "Compatible Google/Alexa/HomeKit", "Scénarios sur mesure", "Formation à l'usage incluse"],
    duration: "1 à 5 jours selon ampleur",
    warranty: "2 ans matériel",
    faq: [
      { q: "Faut-il refaire l'électricité ?", a: "Non, des solutions sans fil existent pour la majorité des cas." },
      { q: "Quels assistants vocaux supportés ?", a: "Google Assistant, Alexa, Apple HomeKit selon votre choix." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "infogerance-entreprise",
    name: "Infogérance Entreprise",
    shortName: "Infogérance Pro",
    category: "Pro",
    priceFrom: 79,
    priceUnit: "€/mois",
    description: "Maintenance pro mensuelle : MAJ système, sauvegardes auto, monitoring 24/7, support prioritaire.",
    longDescription: "Contrats d'infogérance dédiés TPE/PME : monitoring 24/7, mises à jour système et sécurité, sauvegardes automatisées, support prioritaire, interventions illimitées dans la formule Premium.",
    benefits: ["Monitoring 24/7", "Sauvegardes automatiques", "MAJ sécurité et antivirus", "Support prioritaire", "3 formules : Essentiel, Pro, Premium"],
    duration: "Engagement mensuel",
    warranty: "Engagement de service (SLA)",
    faq: [
      { q: "Combien ça coûte par mois ?", a: "Pack Essentiel 79€/mois, Pro 149€/mois, Premium 299€/mois (interventions illimitées)." },
      { q: "Y a-t-il un engagement ?", a: "Engagement minimum 6 mois, puis sans engagement." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "suppression-virus",
    name: "Suppression Virus & Malware",
    shortName: "Anti-Virus",
    category: "Sécurité",
    priceFrom: 79,
    priceUnit: "€",
    description: "Désinfection complète : virus, ransomware, spyware, adwares. Protection durable installée.",
    longDescription: "Suppression complète de virus, malware, ransomware, spyware. Analyse approfondie, désinfection multi-outils, installation d'une protection durable (Bitdefender, ESET).",
    benefits: ["Désinfection multi-outils pro", "Récupération données possible", "Protection installée incluse", "Formation aux bonnes pratiques", "Garantie 30 jours sans réinfection"],
    duration: "2 à 6 heures",
    warranty: "30 jours sans réinfection",
    faq: [
      { q: "Mon PC est ralenti, est-ce un virus ?", a: "Souvent oui (adwares, miners). Diagnostic gratuit pour confirmer." },
      { q: "Et si c'est un ransomware ?", a: "Diagnostic spécifique. Récupération de données dans certains cas. Aucun paiement de rançon." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "installation-windows",
    name: "Installation Windows 11",
    shortName: "Install. Windows",
    category: "Logiciel",
    priceFrom: 89,
    priceUnit: "€",
    description: "Réinstallation Windows 11 propre, drivers, logiciels essentiels, transfert de données.",
    longDescription: "Réinstallation Windows 11 (ou 10) propre : sauvegarde des données, formatage, installation, drivers à jour, suite logicielle essentielle, restauration des données utilisateur.",
    benefits: ["Sauvegarde données complète", "Drivers officiels constructeur", "Suite logicielle essentielle", "Activation Windows incluse", "Configuration personnalisée"],
    duration: "3 à 5 heures",
    warranty: "1 mois de support installation",
    faq: [
      { q: "Combien coûte une réinstallation Windows ?", a: "89€ tout compris (sauvegarde + install + drivers + activation)." },
      { q: "Je perds mes données ?", a: "Non, sauvegarde systématique avant formatage, restitution après réinstallation." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "formation-informatique",
    name: "Formation Informatique",
    shortName: "Formation",
    category: "Pédagogie",
    priceFrom: 75,
    priceUnit: "€/h",
    description: "Cours individuels Windows, internet, smartphone, bureautique. Tous niveaux, à domicile.",
    longDescription: "Formations individuelles à domicile ou en visio : Windows, internet et messagerie, smartphone Android/iPhone, Word/Excel, photos numériques. Adaptées aux seniors et débutants.",
    benefits: ["Cours individuels à domicile", "Rythme adapté à chacun", "Supports écrits remis", "Senior friendly", "Forfaits 5h/10h dégressifs"],
    duration: "Sessions de 1h à 2h",
    warranty: "Satisfait ou remboursé 1ère heure",
    faq: [
      { q: "C'est adapté aux seniors ?", a: "Oui, c'est même notre spécialité. Pédagogie patiente, rythme adapté." },
      { q: "À domicile ou en visio ?", a: "Les deux. À domicile recommandé pour les débutants." },
    ],
    ctaPath: "/contact",
    schemaType: "Service",
  },
  {
    slug: "upgrade-optimisation-pc",
    name: "Upgrade & Optimisation PC",
    shortName: "Upgrade PC",
    category: "Maintenance",
    priceFrom: 75,
    priceUnit: "€",
    description: "Boostez votre PC : SSD NVMe, RAM, carte graphique, ventilation, Windows réinstallé propre.",
    longDescription: "Redonnez une seconde vie à votre ordinateur : remplacement du disque dur par un SSD NVMe (jusqu'à 10x plus rapide), ajout de mémoire RAM, upgrade carte graphique, changement ventilateurs et pâte thermique, réinstallation Windows propre avec vos données conservées. Diagnostic complet 75€, devis ferme avant intervention.",
    benefits: ["SSD NVMe : PC 10x plus rapide", "Ajout RAM & carte graphique", "Windows réinstallé propre", "Données transférées incluses", "Garantie 3 mois"],
    duration: "1 à 3 jours",
    warranty: "3 mois sur l'intervention",
    faq: [
      { q: "Mon PC est très lent, ça vaut le coup d'upgrader ?", a: "Oui dans 90% des cas : un SSD NVMe + 8-16 Go de RAM transforment un PC lent en machine réactive, pour bien moins cher qu'un PC neuf." },
      { q: "Combien coûte un passage au SSD ?", a: "Diagnostic 75€, puis forfait upgrade SSD + réinstallation + transfert de données dès 149€ pièce incluse selon capacité." },
      { q: "Mes fichiers sont-ils conservés ?", a: "Oui, transfert complet de vos documents, photos et logiciels compatibles sur la nouvelle installation." },
    ],
    ctaPath: "/contact",
    schemaType: "ComputerRepairService",
  },
  {
    slug: "reparation-imprimante",
    name: "Réparation Imprimante",
    shortName: "Imprimante",
    category: "Maintenance",
    priceFrom: 49,
    priceUnit: "€",
    description: "Dépannage imprimante jet d'encre et laser : bourrage, tête bouchée, Wifi, scanner, toutes marques.",
    longDescription: "Dépannage imprimantes HP, Epson, Canon, Brother, Samsung : bourrage papier, tête d'impression bouchée, problème Wifi ou réseau, scanner HS, message d'erreur, installation pilotes Windows / Mac. À domicile ou en atelier.",
    benefits: ["Toutes marques (HP, Epson, Canon, Brother)", "Jet d'encre & laser", "Installation Wifi & pilotes", "À domicile ou atelier", "Conseil cartouches & toners"],
    duration: "1 à 3 jours",
    warranty: "3 mois sur intervention",
    faq: [
      { q: "Mon imprimante ne se connecte plus au Wifi ?", a: "Cause fréquente : changement de box. Reconfiguration Wifi + pilotes : 49€." },
      { q: "Vous nettoyez les têtes bouchées ?", a: "Oui, nettoyage profond des têtes Epson / Canon. Si irrécupérable, devis remplacement tête." },
      { q: "Réparez-vous les imprimantes laser ?", a: "Oui : tambour, four, rouleaux d'entraînement, capteurs. Pièces d'origine HP, Brother, Samsung." },
    ],
    ctaPath: "/contact",
    schemaType: "ComputerRepairService",
  },
  {
    slug: "vente-ordinateur",
    name: "Vente Ordinateur & Magasin Informatique",
    shortName: "Magasin PC",
    category: "Vente",
    priceFrom: 299,
    priceUnit: "€",
    description: "Vente PC fixes, portables reconditionnés et neufs, conseils sur mesure, livraison & installation.",
    longDescription: "Magasin informatique à Béziers : PC portables et fixes neufs et reconditionnés grade A garantis, accessoires (clavier, souris, écran, imprimante, NAS), conseil personnalisé selon usage (bureautique, gaming, pro), livraison et installation à domicile dans tout l'Hérault.",
    benefits: ["PC neufs & reconditionnés garantis", "Conseil personnalisé sans jargon", "Toutes marques (HP, Dell, Lenovo, Asus, Apple)", "Livraison & installation à domicile", "Garantie 1 an minimum"],
    duration: "Disponibilité immédiate ou 48-72h",
    warranty: "1 à 2 ans selon produit",
    faq: [
      { q: "Avez-vous un magasin physique à Béziers ?", a: "Oui, atelier-boutique sur Béziers. Sur rendez-vous pour conseil personnalisé sans attente." },
      { q: "Vendez-vous des PC reconditionnés ?", a: "Oui, PC pro reconditionnés grade A (Dell Latitude, HP EliteBook, Lenovo ThinkPad) avec garantie 1 an, dès 299€." },
      { q: "Pouvez-vous installer le PC chez moi ?", a: "Oui : livraison + installation + transfert de données + formation 1h dès 79€ supplémentaires." },
    ],
    ctaPath: "/contact",
    schemaType: "Store",
  },
  {
    slug: "assistance-bureautique",
    name: "Assistance Bureautique",
    shortName: "Bureautique",
    category: "Formation",
    priceFrom: 75,
    priceUnit: "€",
    description: "Aide Word, Excel, e-mail, imprimante : prise en main et dépannage à domicile ou à distance.",
    longDescription: "Assistance bureautique à Béziers : prise en main de Word, Excel et PowerPoint, configuration des comptes e-mail (Outlook, Gmail), installation d'imprimantes et scanners, installation de logiciels, transfert des fichiers vers un nouveau PC, réglages WiFi. À domicile dans un rayon de 50 km ou à distance, 24h/24 et 7j/7. Diagnostic 75 €, devis gratuit.",
    benefits: ["Aide pas à pas sans jargon", "À domicile ou à distance", "24h/24 et 7j/7", "Diagnostic 75 €, devis gratuit", "Particuliers & professionnels"],
    duration: "1 à 2 heures",
    warranty: "Selon devis",
    faq: [
      { q: "Pouvez-vous m'apprendre à utiliser Word ou Excel ?", a: "Oui : accompagnement pas à pas, à domicile ou à distance, à votre rythme." },
      { q: "L'assistance peut-elle se faire à distance ?", a: "Oui, la plupart des demandes bureautiques se règlent à distance ; à domicile dans un rayon de 50 km." },
      { q: "Configurez-vous les e-mails et les imprimantes ?", a: "Oui : comptes e-mail (Outlook, Gmail…), imprimantes, scanners et connexion des appareils au WiFi." },
    ],
    ctaPath: "/assistance-bureautique",
    schemaType: "Service",
  },
];

// ===== Helpers =====
export const getCity = (slug: string) => cities.find((c) => c.slug === slug);
export const getService = (slug: string) => services.find((s) => s.slug === slug);

// Génère TOUS les couples service+ville pour le sitemap & maillage
export function allServiceCityPairs(): { service: ServiceType; city: City; path: string }[] {
  const pairs: { service: ServiceType; city: City; path: string }[] = [];
  for (const service of services) {
    for (const city of cities) {
      pairs.push({ service, city, path: `/${service.slug}-${city.slug}` });
    }
  }
  return pairs;
}
